/* Morning Light in-article table of contents.

   Builds a jump-link nav from the article's h2 headings and inserts it just
   before the first one. Long guides get a scannable map and a shot at Google
   sitelinks; short articles get nothing, because a two-item TOC is noise.

   Progressive enhancement only: article bodies are plain HTML with no markers
   to add, so this works on all 200+ existing articles without touching them.
   If anything is missing or unexpected, it renders nothing rather than throw. */
(function () {
  'use strict';

  var MIN_HEADINGS = 4;

  function slugify(text, used) {
    var base = String(text || '')
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (!base) { base = 'section'; }
    var id = base;
    var n = 2;
    while (used[id]) {
      id = base + '-' + n;
      n++;
    }
    used[id] = true;
    return id;
  }

  function build(container) {
    var headings = container.querySelectorAll('h2');
    if (!headings || headings.length < MIN_HEADINGS) { return; }

    // Respect ids the page already uses so we never break an existing anchor.
    var used = {};
    var existing = container.querySelectorAll('[id]');
    for (var e = 0; e < existing.length; e++) {
      used[existing[e].id] = true;
    }

    var nav = document.createElement('nav');
    nav.className = 'ml-toc';
    nav.setAttribute('aria-label', 'On this page');

    var label = document.createElement('p');
    label.className = 'ml-toc__label';
    label.textContent = 'On this page';
    nav.appendChild(label);

    var list = document.createElement('ul');
    list.className = 'ml-toc__list';

    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      var text = (h.textContent || '').trim();
      if (!text) { continue; }
      if (!h.id) { h.id = slugify(text, used); }

      var li = document.createElement('li');
      li.className = 'ml-toc__item';
      var a = document.createElement('a');
      a.className = 'ml-toc__link';
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);
    }

    if (!list.children.length) { return; }
    nav.appendChild(list);

    var first = headings[0];
    if (first.parentNode) {
      first.parentNode.insertBefore(nav, first);
    }

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { return; }

    nav.addEventListener('click', function (evt) {
      var link = evt.target && evt.target.closest ? evt.target.closest('.ml-toc__link') : null;
      if (!link) { return; }
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target || !target.scrollIntoView) { return; }
      evt.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Keep the keyboard on the same journey as the scroll.
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      if (history && history.replaceState) {
        history.replaceState(null, '', link.getAttribute('href'));
      }
    });
  }

  function init() {
    var container =
      document.querySelector('.article__content') ||
      document.querySelector('.rte--article') ||
      document.querySelector('[data-article-content]') ||
      document.querySelector('main article .rte') ||
      document.querySelector('main .rte');
    if (!container) { return; }
    try {
      build(container);
    } catch (err) {
      /* never let a nice-to-have break the page */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
